/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { ErrorHandler, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { provideServiceWorker } from '@angular/service-worker'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { tokenInterceptor } from './app/interceptors/token-http.interceptor'
import { loaderInterceptor } from './app/interceptors/loader-http.interceptor'
import { DatePipe, registerLocaleData } from '@angular/common'
import localePt from '@angular/common/locales/pt'
import { provideNgxMask } from 'ngx-mask'
import { GlobalErrorHandler } from './app/utils/global-error-handler'
import { routes } from './app/app.routes'
import { TranslateModule } from '@ngx-translate/core'
import { environment } from 'src/environments/environment'
import { AppComponent } from './app/app.component'

registerLocaleData(localePt)

// Fire-and-forget: inicia download do chunk Faro/OTel imediatamente, não bloqueia bootstrap
import('./app/faro-initializer').then(m => m.faroInitializer()())

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    importProvidersFrom(TranslateModule.forRoot()),
    ...provideTranslateHttpLoader(),
    DatePipe,
    provideNgxMask(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(withInterceptors([tokenInterceptor, loaderInterceptor])),
  ],
}).catch(err => console.error(err))
